import { createStyles } from '@material-ui/core';
export default (function (theme) {
  return createStyles({
    filter: {
      marginBottom: theme.spacing(1),
      position: 'relative'
    },
    filterClosed: {
      marginBottom: 0
    },
    filterToggle: {
      position: 'absolute',
      top: '-46px',
      right: 0,
      zIndex: 1
    },
    filterToggleClosed: {
      backgroundColor: theme.palette.grey.A200,
      '&:hover': {
        backgroundColor: theme.palette.grey.A700
      }
    }
  });
});